
import { DisplayAds } from '../DisplayAds';

export class DisplayAdsSite extends DisplayAds {

  constructor(props) {
    super(props, { pageForOrgType: 'SITE' })
  }
}


// WEBPACK FOOTER //
// ./src/screens/admin/sites/DisplayAdsSite.js